import React from "react";
import { handleMailClick } from "../../utils/actions";
import "./index.css";
function FillButton({ onClick, name = "Press Me" }) {
  
  return (
    <div className="btn-gradient" onClick={onClick} style={{ height: "3rem" }}>
      <p onClick={handleMailClick} className="text-1xl">
        {name}
      </p>
    </div>
  );
}

export default FillButton;
